import React, { useEffect, useState } from "react";
import "../Styles/Profile.css";
import Footer from "../Core/Footer";
import { IoMdHome } from "react-icons/io";
import { MdOutlineShoppingBag } from "react-icons/md";
import { SlWallet } from "react-icons/sl";
import { FaRegHeart } from "react-icons/fa";
import { getPages, getProfile } from "../Services/Operations/ProductAPI";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useNavigation } from "react-router";
import { logout } from "../Redux/user_information";
import { FaPowerOff } from "react-icons/fa6";

const Profile = () => {
  const dispatch = useDispatch();
  const token = useSelector((state) => state.user.token);
  const user_id = useSelector((state) => state.user.userId);
  const avatar = useSelector((state) => state.user.avatar);
  const [logoutPopup, setLogoutPopup] = useState(false);
  const [profileData, setProfileData] = useState({});
  const [pages, setPages] = useState([]);
  const [body, setBody] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const location = useLocation();
  const { longitude, latitude } = location.state || {};
  const navigation = useNavigate();

  console.log("latitude : ", latitude);
  console.log("longitude : ", longitude);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const formData = new FormData();
        formData.append("token", token);
        formData.append("user_id", user_id);

        for (let pair of formData.entries()) {
          //console.log(`${pair[0]}: ${pair[1]}`);
        }

        const response = await getProfile(formData);
        const response1 = await getPages();

        if (response && response.data) {
          //console.log("Profile Data:", response.data);
          setProfileData(response.data);
        }

        if (response1) {
          //console.log("Pages Data:", response1);
          setPages(response1);
        }
      } catch (error) {
        console.error("Error fetching profile or pages:", error);
      }
    };

    fetchProfile();
  }, [token, user_id]);

  useEffect(() => {
    if (!token) {
      navigation("/login");
    }
  }, [token, navigation]);

  const handlePageClick = (data) => {
    const formattedData = data
      .replace(/<p[^>]*>/g, "")
      .replace(/<span[^>]*>/g, "")
      .replace(/<header[^>]*>/g, "")
      .replace(/<h3[^>]*>/g, "")
      .replace(/<div[^>]*>/g, "")
      .replace(/<ul[^>]*>/g, "")
      .replace(/<li[^>]*>/g, "")
      .replace(/<a[^>]*>/g, "")
      .replace(/<\/?(p|span|header|h3|div|ul|li|a)>/g, "")
      .replace(/\sstyle="[^"]*"/g, "")
      .replace(/&nbsp;/g, "")
      .replace(/<br\s*\/?>/g, "\n");

    const formattedBody = formattedData
      .split("\n")
      .filter((line) => line.trim() !== "");
    setBody(formattedBody);
    setShowPopup(true);
  };

  const handleManage = (data) => {
    //console.log("data manage : ", data)
    navigation("/manage-page", { state: { data } });
  };

  const handleClosePopup = () => {
    setShowPopup(false);
  };
  const handleLogout = () => {
    dispatch(logout());
    navigation("/login");
  };

  const handlelogpopup = () => {
    setLogoutPopup(true);
  };

  return (
    <div style={{ width: "100%", backgroundColor: "#f2f2f2" }}>
      {showPopup && (
        <div
          className="popup-overlay"
          style={{ backgroundColor: "white", zIndex: 9999 }}
        >
          <div className="popup-content1">
            <button className="close-btn" onClick={handleClosePopup}>
              ×
            </button>
            <div style={{ marginTop: "71px", textAlign: "justify" }}>
              {body.map((line, index) => (
                <p key={index}>
                  {line}
                  <br />
                </p>
              ))}
            </div>
          </div>
        </div>
      )}

      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <div className="profile-header">
          <h2>{profileData.name || "Name not available"}</h2>
          <p>{profileData.phone || "Phone not available"}</p>
          <p>{profileData.email || "Email not available"}</p>
        </div>
        <div onClick={() => navigation("/get-avature")}>
          <img width="110px" src={avatar} alt="..." />
        </div>
      </div>

      <div className="profile-page">
        <div className="account-section">
          <h3>My Account</h3>
          <div className="account-options">
            <div className="account-option">
              <div
                onClick={() => handleManage(profileData)}
                style={{
                  position: "relative",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "24px",
                }}
              >
                <div
                  style={{
                    backgroundColor: "#5d5dff",
                    width: "40px",
                    height: "40px",
                    borderRadius: "50%",
                  }}
                ></div>
                <span
                  style={{
                    position: "absolute",
                    top: "6px",
                    left: "40px",
                    color: "white",
                    fontSize: "24px",
                  }}
                >
                  <IoMdHome style={{ color: "white" }} />
                </span>
                <span>Manage Address</span>
              </div>
            </div>
            <div className="account-option">
              <div
                onClick={() => navigation("/my-order")}
                style={{
                  position: "relative",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "24px",
                }}
              >
                <div
                  style={{
                    backgroundColor: "#ed04f8",
                    width: "40px",
                    height: "40px",
                    borderRadius: "50%",
                  }}
                ></div>
                <span
                  style={{
                    position: "absolute",
                    top: "6px",
                    left: "22px",
                    color: "white",
                    fontSize: "24px",
                  }}
                >
                  <MdOutlineShoppingBag style={{ color: "white" }} />
                </span>
                <span>My Orders</span>
              </div>
            </div>
            <div className="account-option">
              <div
                onClick={() => navigation("/wallet")}
                style={{
                  position: "relative",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "24px",
                }}
              >
                <div
                  style={{
                    backgroundColor: "green",
                    width: "40px",
                    height: "40px",
                    borderRadius: "50%",
                  }}
                ></div>
                <span
                  style={{
                    position: "absolute",
                    top: "6px",
                    left: "22px",
                    color: "white",
                    fontSize: "24px",
                  }}
                >
                  <SlWallet style={{ color: "white" }} />
                </span>
                <span>My Wallet</span>
              </div>
            </div>
            <div
              className="account-option"
              onClick={() =>
                navigation("/favorite", { state: { longitude, latitude } })
              }
            >
              <div
                style={{
                  position: "relative",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "24px",
                }}
              >
                <div
                  style={{
                    backgroundColor: "red",
                    width: "40px",
                    height: "40px",
                    borderRadius: "50%",
                  }}
                ></div>
                <span
                  style={{
                    position: "absolute",
                    top: "6px",
                    left: "31px",
                    color: "white",
                    fontSize: "24px",
                  }}
                >
                  <FaRegHeart style={{ color: "white" }} />
                </span>
                <span>My Favourites</span>
              </div>
            </div>
          </div>
        </div>

        <div className="help-section">
          <h3>Help & FAQs</h3>
          <div className="help-options">
            {pages.map((page, index) => (
              <button
                key={index}
                onClick={() => {
                  handlePageClick(page.body);
                }}
                className="help-option"
              >
                {page.name}
              </button>
            ))}
          </div>
        </div>

        <div className="logout-section" onClick={handlelogpopup}>
          <button className="logout-btn">
            <FaPowerOff />
            Logout
          </button>
        </div>

        <div className="language-section">
          <span>Change Language</span>
          <select>
            <option value="en">English</option>
            <option value="hi">Hindi</option>
          </select>
        </div>

        <Footer longitude={longitude} latitude={latitude} />
      </div>
      {logoutPopup && (
        <div className="popup-overlay">
          <div
            className="popup-content"
            onClick={handleLogout}
            style={{ maxWidth: "122px", width: "42%" }}
          >
            <p
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "14px",
              }}
            >
              <FaPowerOff style={{ color: "red", fontSize: "22px" }} />
              Logout
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default Profile;
